let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gYg2y")).then(() => parcelRequire('kJ9vR'));